(function () {
  function deliveryDate(lang) {
    var d = new Date();
    d.setHours(12, 0, 0, 0);
    var added = 0;
    while (added < 3) {
      d.setDate(d.getDate() + 1);
      var weekday = d.getDay();
      if (weekday !== 0 && weekday !== 6) added++;
    }
    var isFr = (lang || "").indexOf("fr") === 0;
    var daysFr = ["dimanche", "lundi", "mardi", "mercredi", "jeudi", "vendredi", "samedi"];
    var monthsFr = [
      "janvier",
      "février",
      "mars",
      "avril",
      "mai",
      "juin",
      "juillet",
      "août",
      "septembre",
      "octobre",
      "novembre",
      "décembre",
    ];
    if (isFr) {
      return daysFr[d.getDay()] + " " + d.getDate() + " " + monthsFr[d.getMonth()];
    }
    return d.toLocaleDateString(lang || "en", { weekday: "long", day: "numeric", month: "long" });
  }

  function productData(form) {
    if (window.jQuery) {
      var data = window.jQuery(form).data("product");
      if (data) return data;
    }
    try {
      return JSON.parse(form.getAttribute("data-product") || "{}");
    } catch (e) {
      return {};
    }
  }

  function findVariant(form, variantId) {
    var variants = productData(form).variants || [];
    for (var i = 0; i < variants.length; i++) {
      if (String(variants[i].id) === String(variantId)) return variants[i];
    }
    return null;
  }

  function syncSelect(form, variantId) {
    var variant = findVariant(form, variantId);
    var optionSelectors = form.querySelectorAll(".single-option-selector");
    if (variant && optionSelectors.length) {
      for (var i = 0; i < optionSelectors.length; i++) {
        var val = variant["option" + (i + 1)];
        if (val != null) optionSelectors[i].value = val;
      }
      var first = optionSelectors[0];
      if (window.jQuery) {
        window.jQuery(first).trigger("change");
      } else if (typeof first.onchange === "function") {
        first.onchange({});
      } else {
        first.dispatchEvent(new Event("change", { bubbles: true }));
      }
    }

    form.querySelectorAll("select[name='id'], input[name='id']").forEach(function (el) {
      el.disabled = false;
      el.value = variantId;
    });

    form.querySelectorAll("[data-var-id]").forEach(function (el) {
      el.setAttribute("data-var-id", String(variantId));
    });
    syncGallery(variant);
  }

  function imageFile(src) {
    if (!src) return "";
    return String(src).split("?")[0].split("/").pop();
  }

  function syncGallery(variant) {
    if (!variant || !variant.featured_image) return;
    var gallery = document.querySelector(".js-product-page-gallery .js-product-gallery, .js-product-gallery");
    if (!gallery) return;
    var image = variant.featured_image;
    var imageId = image.id != null ? String(image.id) : "";
    var file = imageFile(image.src);
    var match = null;
    var nodes = gallery.querySelectorAll("[data-image-id], img");
    for (var i = 0; i < nodes.length; i++) {
      var node = nodes[i];
      var id = node.getAttribute("data-image-id");
      var src = node.getAttribute("src") || node.getAttribute("data-src") || "";
      if ((imageId && id && String(id) === imageId) || (file && src.indexOf(file) !== -1)) {
        match = node.closest(".gallery-cell") || node;
        break;
      }
    }
    if (!match) return;
    var cells = gallery.querySelectorAll(".gallery-cell");
    var index = -1;
    for (var c = 0; c < cells.length; c++) {
      if (cells[c] === match || cells[c].contains(match)) {
        index = c;
        break;
      }
    }
    if (index < 0) {
      var dataIndex = match.getAttribute("data-index") || (match.querySelector && match.querySelector("[data-index]") && match.querySelector("[data-index]").getAttribute("data-index"));
      index = parseInt(dataIndex, 10);
    }
    if (isNaN(index) || index < 0) return;
    if (window.Flickity) {
      var flkty = Flickity.data(gallery);
      if (flkty) {
        flkty.select(index, false, false);
        return;
      }
    }
    if (window.jQuery && window.jQuery.fn.flickity) {
      window.jQuery(gallery).flickity("select", index, false, false);
    }
  }

  function syncCards(form) {
    var select = form.querySelector("select[name='id']");
    if (!select) return;
    form.querySelectorAll(".ttl-qty-card").forEach(function (card) {
      var input = card.querySelector(".ttl-qty-card__input");
      if (!input) return;
      var on = String(input.value) === String(select.value);
      input.checked = on;
      card.classList.toggle("is-selected", on);
    });
    syncUnitRow(form);
  }

  function forceQty(form) {
    form.querySelectorAll("input.quantity").forEach(function (el) {
      el.value = "1";
    });
  }

  function requestedPack() {
    try {
      var params = new URLSearchParams(window.location.search);
      if (params.get("variant")) return 0;
      var pack = params.get("pack");
      if (pack === "1" || pack === "3" || pack === "6") return parseInt(pack, 10);
      return 3;
    } catch (e) {
      return 3;
    }
  }

  function applyInitialPack(form) {
    if (form.getAttribute("data-ttl-user-pack") === "1") return;
    var pack = requestedPack();
    var input = null;
    if (pack) {
      input = form.querySelector('.ttl-qty-card__input[data-ttl-qty="' + pack + '"]:not([disabled])');
    }
    if (!input) {
      input = form.querySelector(".ttl-qty-card__input:checked") || form.querySelector(".ttl-qty-card__input:not([disabled])");
    }
    if (!input) return;
    input.checked = true;
    form.querySelectorAll(".ttl-qty-card").forEach(function (card) {
      card.classList.toggle("is-selected", card.contains(input));
    });
    forceQty(form);
    syncSelect(form, input.value);
    syncComputedCompare(form);
    syncUnitRow(form);
    syncShipping(form);
  }

  function syncComputedCompare(form) {
    var input = form.querySelector(".ttl-qty-card__input:checked");
    var card = input && input.closest(".ttl-qty-card");
    var compare = card ? card.getAttribute("data-ttl-compare") : "";
    var was = form.querySelector(".was_price");
    if (!was) {
      var root = form.closest(".js-product_section") || form.closest(".product_section") || form;
      was = root.querySelector(".was_price");
    }
    if (!was) return;
    if (compare) {
      was.innerHTML = '<div class="money">' + compare + "</div>";
    } else if (!was.querySelector(".money")) {
      was.innerHTML = "";
    }
  }

  function decodeEntities(str) {
    if (!str || str.indexOf("&") === -1) return str;
    var t = document.createElement("textarea");
    t.innerHTML = str;
    return t.value;
  }

  function val(form, selector) {
    var el = form.querySelector(selector);
    return el ? decodeEntities(el.value) : "";
  }

  function optionPrice(option) {
    if (!option) return "";
    var el = option.querySelector(".rc-option__price");
    return el ? el.textContent.replace(/\s+/g, " ").trim() : "";
  }

  function optionInput(option) {
    return option.querySelector("input[type='radio'], .rc-radio__input");
  }

  function optionChecked(option) {
    if (!option) return false;
    var input = optionInput(option);
    if (input) return !!input.checked;
    return option.classList.contains("rc-option--active");
  }

  function clickOption(option) {
    var input = optionInput(option);
    if (input) {
      input.click();
      return;
    }
    var label = option.querySelector("label");
    if (label) label.click();
    else option.click();
  }

  function setText(el, text) {
    if (el && el.textContent !== text) el.textContent = text;
  }

  function selectedQty(form) {
    var input = form.querySelector(".ttl-qty-card__input:checked");
    if (!input) return 1;
    return parseInt(input.getAttribute("data-ttl-qty") || "1", 10) || 1;
  }

  function optionBlob(plan) {
    var opts = (plan && plan.options) || [];
    var out = "";
    for (var i = 0; i < opts.length; i++) {
      var o = opts[i];
      if (o && typeof o === "object") out += " " + (o.value || "") + " " + (o.name || "");
      else out += " " + o;
    }
    return out.toLowerCase();
  }

  function parseMonthNumber(text) {
    var t = String(text || "").toLowerCase().replace(/,/g, ".");
    var m = t.match(/(\d+(?:\.\d+)?)\s*mois/);
    if (m) return parseFloat(m[1]) || 0;
    m = t.match(/every\s+(\d+(?:\.\d+)?)\s*months?/);
    if (m) return parseFloat(m[1]) || 0;
    m = t.match(/(\d+(?:\.\d+)?)\s*-?\s*months?\b/);
    if (m) return parseFloat(m[1]) || 0;
    m = t.match(/(\d+)\s*-?\s*days?\b/);
    if (m) return Math.round((parseInt(m[1], 10) / 30) * 10) / 10;
    m = t.match(/(\d+)\s*jours?\b/);
    if (m) return Math.round((parseInt(m[1], 10) / 30) * 10) / 10;
    return 0;
  }

  function planMonths(plan) {
    if (!plan) return 0;
    var fromName = parseMonthNumber(plan.name);
    if (fromName) return fromName;
    return parseMonthNumber(optionBlob(plan));
  }

  function planScore(plan, qty) {
    var blob = (String(plan.name || "") + " " + optionBlob(plan)).toLowerCase();
    var months = planMonths(plan);
    if (qty === 1 && (blob.indexOf("45-day") !== -1 || Math.abs(months - 1.5) < 0.05)) return 5;
    if (qty === 3 && (blob.indexOf("135-day") !== -1 || Math.abs(months - 4.5) < 0.05)) return 5;
    if (qty === 6 && (blob.indexOf("8-month") !== -1 || Math.abs(months - 8) < 0.05)) return 5;
    return 0;
  }

  function listedPlans(root) {
    var el = root.querySelector("[data-ttl-selling-plans]");
    if (el) {
      try {
        var listed = JSON.parse(el.textContent || "[]");
        if (listed && listed.length) return listed;
      } catch (e) {}
    }
    var groups = productData(root).selling_plan_groups || [];
    var out = [];
    for (var g = 0; g < groups.length; g++) {
      var plans = groups[g].selling_plans || [];
      for (var p = 0; p < plans.length; p++) out.push(plans[p]);
    }
    return out;
  }

  function sellingPlanForVariant(form) {
    var input = form.querySelector(".ttl-qty-card__input:checked");
    var variant = findVariant(form, input && input.value);
    var plans = listedPlans(form);
    var allocs = (variant && variant.selling_plan_allocations) || [];
    if (allocs.length) {
      var id = allocs[0].selling_plan_id;
      for (var i = 0; i < plans.length; i++) {
        if (String(plans[i].id) === String(id)) return plans[i];
      }
    }
    return sellingPlanForQty(form, selectedQty(form));
  }

  function sellingPlanForQty(form, qty) {
    var plans = listedPlans(form);
    var best = null;
    var bestScore = 0;
    for (var p = 0; p < plans.length; p++) {
      var plan = plans[p];
      var score = planScore(plan, qty);
      if (score > bestScore) {
        bestScore = score;
        best = plan;
      }
    }
    return best;
  }

  function sellingPlanIdForQty(form, qty) {
    var best = sellingPlanForVariant(form) || sellingPlanForQty(form, qty);
    return best && best.id ? String(best.id) : "";
  }

  function isSubsave(form) {
    var box = form && form.querySelector && form.querySelector(".ttl-rc-subscribe__input");
    if (box && form.getAttribute("data-ttl-user-sub") === "1") return !!box.checked;
    if (box && box.checked) return true;
    return optionChecked(findRcOptions(form).subsave);
  }

  var applyingPlan = false;

  function productFormRoot(node) {
    if (!node) return null;
    if (node.closest) {
      return node.closest(".ttl-qty-cards-pdp") || node.closest("[data-product-form]") || node;
    }
    return node;
  }

  function nativeProductForm(root) {
    if (!root) return null;
    if (root.tagName === "FORM") return root;
    return root.querySelector("form") || root.closest("form") || root;
  }

  function applySellingPlan(root) {
    var form = productFormRoot(root);
    if (!form || applyingPlan) return;
    var htmlForm = nativeProductForm(form);
    var sub = isSubsave(form);
    var planId = sub ? sellingPlanIdForQty(form, selectedQty(form)) : "";
    if (sub && !planId) return;
    applyingPlan = true;
    try {
      var nodes = form.querySelectorAll('[name="selling_plan"]');
      if (!nodes.length && planId && htmlForm) {
        var hidden = document.createElement("input");
        hidden.type = "hidden";
        hidden.name = "selling_plan";
        htmlForm.appendChild(hidden);
        nodes = form.querySelectorAll('[name="selling_plan"]');
      }
      for (var i = 0; i < nodes.length; i++) {
        var el = nodes[i];
        if (el.type === "radio") {
          el.checked = String(el.value) === String(planId);
          continue;
        }
        if (String(el.value) === String(planId)) continue;
        el.value = planId;
      }
    } finally {
      applyingPlan = false;
    }
  }

  function parseCents(text) {
    if (!text) return 0;
    var t = String(text).replace(/\u00a0/g, " ").trim();
    var m = t.match(/(\d+)[.,](\d{2})/);
    if (m) return parseInt(m[1], 10) * 100 + parseInt(m[2], 10);
    var n = t.replace(/[^\d]/g, "");
    return parseInt(n, 10) || 0;
  }

  function formatMoneyFromCents(cents) {
    var form = document.querySelector(".ttl-qty-cards-pdp");
    var fmt = form && form.getAttribute("data-money-format");
    if (window.Shopify && typeof Shopify.formatMoney === "function") {
      return Shopify.formatMoney(cents, fmt || undefined);
    }
    return (cents / 100).toFixed(2).replace(".", ",") + " €";
  }

  function syncUnitRow(form) {
    var wrap = form.querySelector("[data-ttl-qty-units]");
    if (!wrap) return;
    var qty = selectedQty(form);
    wrap.querySelectorAll("[data-ttl-unit-qty]").forEach(function (el) {
      var q = parseInt(el.getAttribute("data-ttl-unit-qty") || "0", 10);
      el.classList.toggle("is-active", q === qty && q > 1);
    });
  }

  function syncAtcPrice(form) {
    var cents = selectedPayableCents(form);
    if (!cents) return;
    var money = formatMoneyFromCents(cents);
    form.querySelectorAll(".add_to_cart .current_price .money").forEach(function (el) {
      setText(el, money);
    });
  }

  function selectedPayableCents(form) {
    var input = form.querySelector(".ttl-qty-card__input:checked");
    var card = input && input.closest(".ttl-qty-card");
    var oneTime = parseInt((card && card.getAttribute("data-ttl-price")) || "0", 10) || 0;
    if (isSubsave(form)) {
      var rc = findRcOptions(form);
      var cents = parseCents(optionPrice(rc.subsave));
      if (cents) return cents;
      var subPrice = form.querySelector(".ttl-rc-card--sub .ttl-rc-card__price");
      cents = parseCents(subPrice && subPrice.textContent);
      if (cents) return cents;
      if (oneTime) return Math.round(oneTime * 0.8);
    }
    return oneTime;
  }

  function syncShipping(form) {
    var el = form.querySelector("[data-ttl-shipping]");
    if (!el) return;
    var threshold = parseInt(el.getAttribute("data-ttl-shipping-threshold") || "7900", 10);
    var free = val(form, "[data-ttl-shipping-free]");
    var from = val(form, "[data-ttl-shipping-from]");
    var cents = selectedPayableCents(form);
    setText(el, cents >= threshold ? free : from);
  }

  function updateSubEconomy(form) {
    var el = form.querySelector(".ttl-rc-card__economy");
    if (!el) return;
    var onetime = form.querySelector(".rc-option__onetime");
    var subsave = form.querySelector(".rc-option__subsave");
    var save = parseCents(optionPrice(onetime)) - parseCents(optionPrice(subsave));
    var tpl = val(form, "[data-ttl-sub-economy]") || "__AMOUNT__ d'économie";
    if (save > 0) {
      el.hidden = false;
      setText(el, tpl.replace(/__AMOUNT__/g, formatMoneyFromCents(save)));
    } else {
      el.hidden = true;
      setText(el, "");
    }
  }

  var mountingRc = false;

  function findRcOptions(root) {
    if (!root || !root.querySelector) return { onetime: null, subsave: null };
    return {
      onetime:
        root.querySelector(".rc-option__onetime") ||
        root.querySelector(".rc-option--onetime") ||
        root.querySelector(".rc_widget__option--onetime"),
      subsave:
        root.querySelector(".rc-option__subsave") ||
        root.querySelector(".rc-option--subsave") ||
        root.querySelector(".rc_widget__option--subsave"),
    };
  }

  function hideNativeRc(root) {
    if (!root || !root.querySelectorAll) return;
    root.querySelectorAll(".rc-container-wrapper, .rc_container_wrapper").forEach(function (el) {
      el.classList.add("ttl-rc-native");
    });
  }

  function mountRcCards(form) {
    if (!form || mountingRc) return;
    hideNativeRc(form);
    var ui = form.querySelector(".ttl-rc-cards");
    if (!ui) return;

    var rc = findRcOptions(form);
    var checkbox = ui.querySelector(".ttl-rc-subscribe__input");
    if (checkbox && checkbox.getAttribute("data-ttl-rc-bound") !== "1") {
      checkbox.setAttribute("data-ttl-rc-bound", "1");
      function applySubscribeChoice() {
        form.setAttribute("data-ttl-user-sub", "1");
        var uiBox = ui.querySelector(".ttl-rc-card--sub");
        if (uiBox) uiBox.classList.toggle("is-selected", !!checkbox.checked);
        applySellingPlan(form);
        syncShipping(form);
        syncAtcPrice(form);
        var opts = findRcOptions(form);
        mountingRc = true;
        try {
          if (checkbox.checked) {
            if (opts.subsave && !optionChecked(opts.subsave)) clickOption(opts.subsave);
          } else if (opts.onetime && !optionChecked(opts.onetime)) {
            clickOption(opts.onetime);
          }
        } finally {
          mountingRc = false;
        }
      }
      checkbox.addEventListener("change", applySubscribeChoice);
    }

    if (
      form.getAttribute("data-ttl-rc-defaulted") !== "1" &&
      rc.onetime &&
      rc.subsave &&
      optionChecked(rc.subsave)
    ) {
      form.setAttribute("data-ttl-rc-defaulted", "1");
      mountingRc = true;
      try {
        clickOption(rc.onetime);
      } finally {
        mountingRc = false;
      }
    }

    syncRcCards(form);
    applySellingPlan(form);
    syncShipping(form);
  }

  function formatMonthLabel(months, form) {
    if (!months) return "";
    if (Math.abs(months - 1) < 0.05) {
      return val(form, "[data-ttl-sub-every-one]") || "tous les mois";
    }
    var rounded = Math.round(months * 10) / 10;
    var label =
      Math.abs(rounded % 1) < 0.05 ? String(Math.round(rounded)) : String(rounded).replace(".", ",");
    var tpl = val(form, "[data-ttl-sub-every]") || "tous les __MONTHS__ mois";
    return tpl.replace(/__MONTHS__/g, label);
  }

  function syncPlanDuration(form) {
    var el = form.querySelector("[data-ttl-sub-duration]");
    if (!el) return;
    var plan = sellingPlanForVariant(form);
    var months = planMonths(plan);
    var label = formatMonthLabel(months, form);
    if (!label && plan && plan.name) {
      label = String(plan.name)
        .replace(/^livraison\s+/i, "")
        .toLowerCase();
    }
    setText(el, label);
  }

  function syncRcCards(form) {
    var ui = form.querySelector(".ttl-rc-cards");
    if (!ui) return;
    var rc = findRcOptions(form);
    var checkbox = ui.querySelector(".ttl-rc-subscribe__input");
    var subOn = isSubsave(form);
    var subBtn = ui.querySelector(".ttl-rc-card--sub");
    if (subBtn) {
      subBtn.classList.toggle("is-selected", subOn);
      setText(subBtn.querySelector(".ttl-rc-card__price"), optionPrice(rc.subsave));
    }
    if (checkbox && form.getAttribute("data-ttl-user-sub") !== "1") {
      checkbox.checked = optionChecked(rc.subsave);
    }
    updateSubEconomy(form);
    syncPlanDuration(form);
    syncShipping(form);
  }

  function fillDelivery(form) {
    var lang = document.documentElement.lang || "fr";
    var date = deliveryDate(lang);
    form.querySelectorAll("[data-ttl-delivery]").forEach(function (el) {
      var tpl = el.getAttribute("data-ttl-delivery-tpl") || el.textContent;
      el.textContent = tpl.replace("__DATE__", date);
    });
  }

  function bind(form) {
    if (!form || form.getAttribute("data-ttl-qty-bound") === "1") return;
    form.setAttribute("data-ttl-qty-bound", "1");
    var scope = form.closest(".product_page_button_fix") || form.closest(".ttl-qty-pdp") || form;
    forceQty(form);
    applyInitialPack(form);
    fillDelivery(form);
    mountRcCards(scope);
    [50, 250, 600].forEach(function (ms) {
      setTimeout(function () {
        applyInitialPack(form);
        syncComputedCompare(form);
        syncUnitRow(form);
        syncRcCards(scope);
        syncShipping(form);
      }, ms);
    });

    form.addEventListener("change", function (e) {
      var t = e.target;
      if (t && t.classList && t.classList.contains("ttl-qty-card__input")) {
        form.setAttribute("data-ttl-user-pack", "1");
        forceQty(form);
        syncSelect(form, t.value);
        syncComputedCompare(form);
        syncUnitRow(form);
        syncPlanDuration(form);
        syncRcCards(scope);
        applySellingPlan(form);
        form.querySelectorAll(".ttl-qty-card").forEach(function (card) {
          card.classList.toggle("is-selected", card.contains(t) && t.checked);
        });
        [50, 250, 600, 1200].forEach(function (ms) {
          setTimeout(function () {
            syncGallery(findVariant(form, t.value));
            syncRcCards(scope);
            applySellingPlan(form);
            syncShipping(form);
          }, ms);
        });
      }
      if (t && (t.matches(".rc-radio__input, .rc-option input[type='radio']") || t.name === "selling_plan")) {
        syncRcCards(scope);
        applySellingPlan(form);
        syncShipping(form);
      }
    });

    var select = form.querySelector("select[name='id']");
    if (select) {
      select.addEventListener("change", function () {
        syncCards(form);
      });
    }

    var nativeForm = nativeProductForm(form);
    if (nativeForm) {
      nativeForm.addEventListener("submit", function () {
        applySellingPlan(form);
      });
    }
    form.addEventListener(
      "click",
      function (e) {
        if (e.target && e.target.closest && e.target.closest(".add_to_cart, [name='add'], .ttl-qty-sticky-bar__btn")) {
          applySellingPlan(form);
        }
      },
      true
    );

    var obs = new MutationObserver(function () {
      if (mountingRc) return;
      hideNativeRc(scope);
      mountRcCards(scope);
      applySellingPlan(form);
    });
    obs.observe(scope, { childList: true, subtree: true });
  }

  function bindStickyAtc() {
    if (document.querySelector(".ttl-qty-sticky-bar")) return;
    var form = document.querySelector(".ttl-qty-pdp .product_page_button_fix .ttl-qty-cards-pdp");
    var btn = document.querySelector(
      ".ttl-qty-pdp .product_page_button_fix .action_button.add_to_cart:not(.add_to_cart_mobile)"
    );
    if (!form || !btn) return;

    var bar = document.createElement("div");
    bar.className = "ttl-qty-sticky-bar";
    bar.innerHTML =
      '<div class="ttl-qty-sticky-bar__card">' +
      '<span class="ttl-qty-sticky-bar__pack"></span>' +
      '<span class="ttl-qty-sticky-bar__plan"></span>' +
      '<span class="ttl-qty-sticky-bar__price"></span>' +
      "</div>" +
      '<button type="button" class="ttl-qty-sticky-bar__btn">' +
      '<span class="text"></span>' +
      '<svg x="0px" y="0px" width="32px" height="32px" viewBox="0 0 32 32" class="added-animation checkmark">' +
      '<path fill="none" stroke-width="2" stroke-linecap="square" stroke-miterlimit="10" d="M9,17l3.9,3.9c0.1,0.1,0.2,0.1,0.3,0L23,11"></path>' +
      "</svg>" +
      "</button>";
    document.body.appendChild(bar);
    var stickyBtn = bar.querySelector(".ttl-qty-sticky-bar__btn");
    var stickyText = stickyBtn.querySelector(".text");
    var stickyCheck = stickyBtn.querySelector(".checkmark");

    function planLabel(card) {
      if (!card) return "";
      var title = card.querySelector(".ttl-rc-card__title");
      if (!title) return "";
      var clone = title.cloneNode(true);
      var badge = clone.querySelector(".ttl-rc-save");
      if (badge) badge.remove();
      return clone.textContent.replace(/\s+/g, " ").trim();
    }

    function sync() {
      var packEl = form.querySelector(".ttl-qty-card.is-selected .ttl-qty-card__name");
      if (!packEl) {
        var checked = form.querySelector(".ttl-qty-card__input:checked");
        if (checked) {
          var card = checked.closest(".ttl-qty-card");
          packEl = card ? card.querySelector(".ttl-qty-card__name") : null;
        }
      }
      var sub = form.querySelector(".ttl-rc-card--sub.is-selected");
      var cardRow = bar.querySelector(".ttl-qty-sticky-bar__card");
      cardRow.classList.toggle("is-sub", !!sub);
      bar.querySelector(".ttl-qty-sticky-bar__pack").textContent = packEl
        ? packEl.textContent.replace(/\s+/g, " ").trim()
        : "";
      bar.querySelector(".ttl-qty-sticky-bar__plan").textContent = sub ? planLabel(sub) : "";
      var priceEl = sub
        ? sub.querySelector(".ttl-rc-card__price")
        : form.querySelector(".ttl-qty-card.is-selected .ttl-qty-card__price");
      bar.querySelector(".ttl-qty-sticky-bar__price").textContent = priceEl
        ? priceEl.textContent.replace(/\s+/g, " ").trim()
        : "";
      stickyText.textContent = val(form, "[data-ttl-sticky-add]") || "Add";

      var r = btn.getBoundingClientRect();
      bar.classList.toggle("is-visible", r.bottom < 0);
    }

    function mirrorAtcAnim() {
      var atcText = btn.querySelector(".text");
      var atcCheck = btn.querySelector(".checkmark");
      stickyText.className = atcText ? atcText.className : "text";
      if (atcCheck) {
        stickyCheck.classList.toggle("checkmark-active", atcCheck.classList.contains("checkmark-active"));
      }
      stickyBtn.classList.toggle("disabled", btn.classList.contains("disabled"));
      stickyBtn.classList.toggle("button-bg-dark", btn.classList.contains("button-bg-dark"));
      if (btn.disabled || btn.classList.contains("disabled")) {
        stickyBtn.setAttribute("disabled", "disabled");
      } else {
        stickyBtn.removeAttribute("disabled");
      }
    }

    new MutationObserver(mirrorAtcAnim).observe(btn, {
      attributes: true,
      attributeFilter: ["class", "disabled"],
      subtree: true,
      childList: true,
    });

    stickyBtn.addEventListener("click", function () {
      if (stickyBtn.disabled || stickyBtn.classList.contains("disabled")) return;
      btn.click();
    });

    sync();
    window.addEventListener("scroll", sync, { passive: true });
    window.addEventListener("resize", sync);
    form.addEventListener("click", function () {
      setTimeout(sync, 50);
      setTimeout(sync, 300);
    });
    form.addEventListener("change", function () {
      setTimeout(sync, 50);
      setTimeout(sync, 300);
    });
  }

  function syncGalleryStickyOffset() {
    var pdp = document.querySelector(".ttl-qty-pdp");
    if (!pdp) return;
    var header = document.querySelector(".new_sticky_header");
    var h = header ? Math.round(header.getBoundingClientRect().height) : 0;
    pdp.style.setProperty("--ttl-header-h", h + 16 + "px");
  }

  function init() {
    document.querySelectorAll(".ttl-qty-cards-pdp").forEach(bind);
    bindStickyAtc();
    syncGalleryStickyOffset();
    if (!window.__ttlGalleryStickyBound) {
      window.__ttlGalleryStickyBound = true;
      window.addEventListener("resize", syncGalleryStickyOffset);
      if (window.ResizeObserver) {
        var header = document.querySelector(".new_sticky_header");
        if (header) new ResizeObserver(syncGalleryStickyOffset).observe(header);
      }
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init);
  } else {
    init();
  }
  document.addEventListener("shopify:section:load", init);
})();
